module.exports = __webpack_public_path__ + "img/b48022e2-e1a2-4931-9827-897b24b19765.39838f60.webp";